export const searchOptions = {
   
    types: ['address'],

  }
export const searchCities = { types: ['(cities)'] }
 